import { Rectangle, Room } from "@mui/icons-material";
import { Button, Select } from "antd";
import React, { useState } from "react";
import { FeatureGroup, MapContainer, TileLayer, GeoJSON } from "react-leaflet";
import { EditControl } from "react-leaflet-draw";
import { useDispatch, useSelector } from "react-redux";
import { selectLicenseList } from "../../api/redux";
import { Formik } from "formik";
import { getAllSubSector } from "../../api/crud";

const { Option, OptGroup } = Select;

export default (props) => {
  const [mapDrawer, setMapDrawer] = useState(null);
  const [isDrawable, setIsDrawable] = useState(true);
  const [mapData, setMapData] = useState(null);
  const [subSectors, setSubSectors] = useState();
  const state = useSelector(selectLicenseList);

  const dispatch = useDispatch();
  return (
    <>
      <div className="col-12 im-map">
        <MapContainer
          maxZoom={15}
          bounds={
            state.province.spanData.type === "MultiPolygon"
              ? state.province?.spanData?.coordinates[0][0].map((el) => {
                  return [el[1], el[0]];
                })
              : state.province?.spanData?.coordinates[0].map((el) => {
                  return [el[1], el[0]];
                })
          }
        >
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            key={1}
          />

          <FeatureGroup>
            <EditControl
              position="topright"
              onCreated={(e) => {
                setIsDrawable(false);
                props.setSpanData(e);
              }}
              edit={{ edit: false }}
              onDeleted={() => [setIsDrawable(true)]}
              onMounted={(drawControl) => {
                if(!mapDrawer){
                  setMapDrawer(drawControl._toolbars.draw._modes);
                }
              }}
              draw={{
                rectangle: false,
                circle: false,
                circlemarker: false,
                marker: isDrawable,
                polygon: isDrawable,
                polyline: false,
              }}
            />
            {state.province && <GeoJSON data={state.province?.spanData} />}
          </FeatureGroup>
        </MapContainer>
      </div>
      <div className="col-12 im-button-div d-flex p-0">
        <div className="col-12 col-md-6">
          <Button
            className="h-100 w-100 im-button d-flex justify-content-center align-items-center"
            onClick={() => {
              mapDrawer.polygon.handler.enable();
            }}
            disabled={!isDrawable}
          >
            <Rectangle />
            <h6 className="my-auto">چند ضلعی</h6>
          </Button>
        </div>
        <div className="d-flex col-12 col-md-6">
          <Button
            className="h-100 w-100 im-button d-flex justify-content-center align-items-center"
            onClick={() => {
              mapDrawer.marker.handler.enable();
            }}
            disabled={!isDrawable}
          >
            <Room />
            <h6 className="my-auto">مارکر</h6>
          </Button>
        </div>
      </div>
    </>
  );
};
